import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import ValueBadge from "./ValueBadge";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./NewPraiseForm.css";

function NewPraiseForm() {
  const [title, setTitle] = useState("");
  const [receiver, setReceiver] = useState("");
  const [message, setMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [visibility, setVisibility] = useState("public");
  const [values, setValues] = useState([]);
  const [formattedValues, setFormattedValues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedValueId, setSelectedValueId] = useState(null);
  const [show, setShow] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/praises/newForm/data`,
        data: {
          organization: state.organization,
          userId: state.userId,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setUsers(response.data.users);
      setValues(response.data.values);
      setSuccess(response.data.success);

      let tempValues = [];
      for (const item of response.data.values) {
        if (response.data.values.includes(item._id)) {
          tempValues.push({
            _id: item._id,
            title: item.title,
            titleEnglish: item.titleEnglish,
            status: true,
          });
        } else {
          tempValues.push({
            _id: item._id,
            title: item.title,
            titleEnglish: item.titleEnglish,
            status: false,
          });
        }
      }

      setFormattedValues(tempValues);
    }
    fetch();
  }, [state.language, state.token, state.organization, state.userId]);

  const checkMessage = (msg) => {
    if (msg.length < 50) {
      return false;
    } else {
      return true;
    }
  };

  const handleSubmit = async () => {
    if (checkMessage(message) === false) {
      handleShow();
      return;
    } else {
      try {
        await axios({
          method: "post",
          url: `${process.env.REACT_APP_BACKEND_URL}/praises`,
          data: {
            title: title,
            receiverId: receiver,
            senderId: state.userId,
            message: message,
            visibility: visibility,
            organization: state.organization,
            values: formattedValues
              .filter((item) => item.status === true)
              .map((item) => {
                return {
                  id: item._id,
                  title: item.title,
                  titleEnglish: item.titleEnglish,
                };
              }),
          },
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });
        navigate("/praises");
      } catch (error) {
        console.log(error.response.data);
      }
    }
  };

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleReceiverChange = (e) => {
    setReceiver(e.target.value);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const handleVisibilityChange = (e) => {
    setVisibility(e.target.value);
  };

  const toggleStatus = (id) => {
    setIsLoading(true);
    let newValues = formattedValues.map((item) => {
      if (item._id === id) {
        item.status = !item.status;
      }
      return item;
    });
    setFormattedValues(newValues);
    setIsLoading(false);
  };

  const handleSelectedValue = (id) => {
    setSelectedValueId(id);
  };

  const renderValueDescription = (id) => {
    const value = values.find((item) => item._id === id);
    if (value) {
      if (state.language === "en") {
        return (
          <Col className="value-description">
            <h6>{value.titleEnglish}</h6>
            <p>{value.descriptionEnglish}</p>
          </Col>
        );
      } else {
        return (
          <Col className="value-description">
            <h6>{value.title}</h6>
            <p>{value.description}</p>
          </Col>
        );
      }
    } else {
      return "";
    }
  };

  if (isLoading === true) {
    return <Spinner animation="border" role="status" />;
  } else {
    if (success === false) {
      return (
        <Container fluid>
          <Row className="align-items-center">
            <Col lg={12} className="no-more-praises-header">
              <h5>{t("Reconocimientos.Reconocimiento.NewForm.NoMore")}</h5>
            </Col>
          </Row>
          <Row>
            <Col>
              <Link to="/praises">
                <Button variant="secondary">
                  {t("Reconocimientos.Reconocimiento.NewForm.Regresar")}
                </Button>
              </Link>
            </Col>
          </Row>
        </Container>
      );
    } else {
      return (
        <Container fluid>
          <Row>
            <Col className="new-account-header">
              <h2>{t("Reconocimientos.Reconocimiento.NewForm.Titulo")}</h2>
            </Col>
          </Row>
          <Row>
            <Col className="new-account-form">
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {state.language === "en" ? "Title" : "Título"}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    onChange={handleTitleChange}
                    value={title}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {state.language === "en"
                      ? "Who is the praise for?"
                      : "Para quien es el reconocimiento?"}
                  </Form.Label>
                  <Form.Select onChange={handleReceiverChange} value={receiver}>
                    <option>
                      {state.language === "en"
                        ? "Select collaborator"
                        : "Seleccionar colaborador"}
                    </option>
                    {users.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.firstName} {user.lastName}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {state.language === "en" ? "Message" : "Mensaje"}
                  </Form.Label>
                  <Form.Control as="textarea" onChange={handleMessageChange} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {state.language === "en" ? "Visibility" : "Visibilidad"}
                  </Form.Label>
                  <Form.Select
                    onChange={handleVisibilityChange}
                    value={visibility}
                  >
                    <option value="">
                      {state.language === "en"
                        ? "Select praise visibility"
                        : "Seleccionar visibilidad del reconocimiento"}
                    </option>
                    <option value="public">
                      {state.language === "en" ? "Public" : "Publico"}
                    </option>
                    <option value="private">
                      {state.language === "en" ? "Private" : "Privado"}
                    </option>
                    <option value="manager">
                      {state.language === "en"
                        ? "Private + Manager"
                        : "Privado + Jefe"}
                    </option>
                  </Form.Select>
                </Form.Group>
                <Col>
                  <h3 className="mb-4 mt-4">
                    {state.language === "en"
                      ? "Value it reflects"
                      : "Valor que refleja"}
                  </h3>
                  <Row>
                    <Col lg={8} className="praise-badges-container">
                      {formattedValues.map((item) => (
                        <ValueBadge
                          key={item._id}
                          id={item._id}
                          title={item.title}
                          titleEnglish={item.titleEnglish}
                          status={item.status}
                          toggleStatus={toggleStatus}
                          language={state.language}
                          handleSelectedValue={handleSelectedValue}
                        />
                      ))}
                    </Col>
                    <Col lg={4}>{renderValueDescription(selectedValueId)}</Col>
                  </Row>
                </Col>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button className="primary" onClick={handleSubmit}>
                {t("Reconocimientos.Reconocimiento.NewForm.Guardar")}
              </Button>
              <Link to="/praises">
                <Button className="danger">
                  {t("Reconocimientos.Reconocimiento.NewForm.Cancelar")}
                </Button>
              </Link>
            </Col>
          </Row>
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>
                {t("Reconocimientos.Reconocimiento.NewForm.Modal.Titulo")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {t("Reconocimientos.Reconocimiento.NewForm.Modal.Pregunta")}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={handleClose}>
                {t("Reconocimientos.Reconocimiento.NewForm.Modal.Cerrar")}
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      );
    }
  }
}

export default NewPraiseForm;
